import {RiverBreakout, Text, Link, Stack} from '@primer/react-brand'
import {renderWithNoMarks, renderPoints} from '../utils'
import type {RiverBreakout as RiverBreakoutProps} from '../../../lib/types/contentful'

export type FlexSuiteRiverBreakoutProps = RiverBreakoutProps['fields']

export const FlexSuiteRiverBreakout = ({
  heading,
  includeCta,
  label,
  href,
  alt,
  supportingContent,
  pointOne,
  pointTwo,
  pointThree,
  // statistics,
  // customerStories,
}: FlexSuiteRiverBreakoutProps) => {
  let trailingContent
  if (supportingContent === 'Points') {
    trailingContent = () => (
      <Stack>
        {pointOne && renderPoints(pointOne)}
        {pointTwo && renderPoints(pointTwo)}
        {pointThree && renderPoints(pointThree)}
      </Stack>
    )
  }

  if (supportingContent === 'Statistics') {
    /* Coming Soon */
    trailingContent = () => null
  }
  if (supportingContent === 'Customer Stories') {
    /* Coming Soon */
    trailingContent = () => null
  }
  return (
    <RiverBreakout>
      {/* Will add visual content here after https://github.com/github/marketing-engineering/issues/5468 */}
      <RiverBreakout.Visual>{/* Visual */}</RiverBreakout.Visual>
      <RiverBreakout.Content {...(trailingContent && {trailingComponent: trailingContent})}>
        {[
          <Text key="heading">{renderWithNoMarks(heading)}</Text>,
          ...(includeCta && href && label
            ? [
                <Link key={href} href={href} {...(alt ? {'aria-label': alt} : {})}>
                  {label}
                </Link>,
              ]
            : []),
        ]}
      </RiverBreakout.Content>
    </RiverBreakout>
  )
}
